<mat-toolbar class="stick-top">
  <mat-icon>schedule</mat-icon>
  Schedule task
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" type="button" (click)="set()" [disabled]="!taskCarrierId || !taskId || !sprintId">
    Update
  </button>
</div>

<div class="padded vbox vbox-space">
  <div>
    <form #form="ngForm" role="form">
      <table class="basicTable">
        <thead>
        <tr>
          <th colspan="100">Schedule task</th>
        </tr>
        <tr>
          <th style="width: 200px;">Carrier</th>
          <th>Task ID</th>
          <th>Sprint ID</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <micro-taskCarrier-select [(taskCarrierId)]="taskCarrierId" [required]="true"></micro-taskCarrier-select>
          </td>
          <td>
            <input [(ngModel)]="taskId" required placeholder="Task ID" id="taskId" name="taskId">
          </td>
          <td>
            <input [(ngModel)]="sprintId" required placeholder="Sprint ID" id="sprintId" name="sprintId">
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>


